import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FormRenderContext } from "../features/form/FormRenderContext.js";
import { AwaitContext } from "../shared/contexts/AwaitContext.js";
import { MessageContext } from "../features/message/MessageContext.js";
import { OfferRenderContext } from "../features/offer/OfferRenderContext.js";
export function CommandRenderer({ command, children }) {
    if (!command) {
        return null;
    }
    switch (command.kind) {
        case "renderForm":
            return (_jsx(FormRenderContext.Provider, { value: {
                    form: command.form,
                    data: command.prefilledData,
                }, children: children }));
        case "renderOffer":
            return (_jsx(OfferRenderContext.Provider, { value: { offer: command.offer }, children: children }));
        case "await":
            return (_jsx(AwaitContext.Provider, { value: { isAwaiting: true }, children: children }));
        case "showMessage":
            return (_jsx(MessageContext.Provider, { value: { message: command.message }, children: children }));
        case "redirect":
            // normally should not enter here
            return null;
        default:
            return _jsx(_Fragment, { children: children });
    }
}
